import React, { useState, useEffect } from 'react';
import './AUDT.css';
import Footer from '../Footer';
import { Link } from 'react-router-dom';

const AUDT = () => {
  const [isLinksVisible, setIsLinksVisible] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      // Set links to be visible if the window width is greater than your breakpoint
      if (window.innerWidth >= 768) {
        setIsLinksVisible(true);
      }

      if (window.innerWidth <= 767) {
        setIsLinksVisible(false);
      }
      

    };

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Call handler right away so state gets updated with initial window size
    handleResize();

    // Remove event listener on cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleLinksVisibility = () => {
    console.log('Toggling links visibility. Current state is:', isLinksVisible);
    setIsLinksVisible(!isLinksVisible);
  };

  

  useEffect(() => {

    console.log('Links visibility state is now:', isLinksVisible);
  }, [isLinksVisible]);

  return (
    <>
    <div className="audt-container">
      {/* <div className="quick-links">
        <button onClick={toggleLinksVisibility} className="toggle-button">
          {isLinksVisible ? 'Hide Links' : 'Show Links'}
        </button>
        {isLinksVisible && (
          <div className="links-container">
            <h3>Quick Links</h3>
            <a href="#goal">Goal</a>
            <a href="#scope">Scope</a>
            <a href="#participants">Involvement</a>
            <a href="#topics">Breakout Topics</a>
            <a href="#outcomes">Workshop Outcomes</a>
          </div>
        )}
      </div> */}


      <header className="page-hero">
        <div className="page-hero__media">
          <img src={process.env.PUBLIC_URL + "/images/grey_digital_twin_city_smart_cities_Adobe.jpg"} alt="" />
        </div>
        <div className="page-hero__inner">
          <p className="page-hero__eyebrow">Workshop</p>
          <h1 className="page-hero__title">Atmospheric and Urban Digital Twins Workshop</h1>
          <div className="page-hero__meta">
            <p>The workshop activities are supported through NSF AGS (2324744; Dr. N. Anderson and C. Lu)</p>
            <p>In partnership with UNESCO, WCRP Digital Earth Lighthouse Activity, Bentley Systems</p>
          </div>
        </div>
      </header>

      <div className="audt-sponsors">
        <div className="logos-container">
          <img className="org-logo org-logo--light" src={process.env.PUBLIC_URL + "/images/UNESCO_logo_white.png"} alt="UNESCO" />
          <img className="org-logo org-logo--light" src={process.env.PUBLIC_URL + "/images/WCRP-logo-for-teal-background.png"} alt="WCRP" />
          <img className="org-logo" src={process.env.PUBLIC_URL + "/images/Bentley_Systems_logo.svg"} alt="Bentley Systems" />
          <img className="org-logo NSF" src={process.env.PUBLIC_URL + "/images/NSF.svg.png"} alt="NSF" />
          <img className="org-logo" src={process.env.PUBLIC_URL + "/images/f_nist-logo-brand-black.png"} alt="NIST" />
        </div>
      </div>

      <div className="audt-body">

      <section className="audt-section u-spread detail-section" id="glance">
        <h2 className="u-spread-label">Most Recent Workshop</h2>
        <div className="detail-section__body">
          <p className="audt-lede">Our latest AUDT (Atmospheric Urban Digital Twin/ City Digital Twin) workshop series was successfully completed on <strong>Thursday, August 7th and Friday, August 8th</strong>.</p>

          <p className="detail-fact__label">Workshop Materials</p>
          <div className="detail-links">
            <a className="detail-link" href="/pdf/AUDT Schedule.pdf" target="_blank" rel="noopener noreferrer">
              Schedule<span className="detail-link__meta">PDF</span>
            </a>
            <a className="detail-link" href="https://utexas.zoom.us/rec/share/DSUGBUHQN_TW-qzLpZ1515QDnszr36q2OHcNTtFcyn65FA4YyYgcqdMWrGUkxCWm.RHCZ0XxvqsA_347_?startTime=1754589648000" target="_blank" rel="noopener noreferrer">
              Day 1 Recording<span className="detail-link__meta">August 7th</span>
            </a>
            <a className="detail-link" href="https://utexas.zoom.us/rec/share/BGtuj6aXW8o81DI5DrQeOOqivQuny0i7qQVgkHy62SypRR48xme4iLcYZOJwTAvt.BzP901XTbT2A_xwo?startTime=1754661789000" target="_blank" rel="noopener noreferrer">
              Day 2 Recording<span className="detail-link__meta">August 8th</span>
            </a>
            <a className="detail-link" href="https://www.youtube.com/watch?v=8XYAgaIrcrk&t=4s" target="_blank" rel="noopener noreferrer">
              Welcome and Intro Video<span className="detail-link__meta">YouTube</span>
            </a>
          </div>

          <dl className="detail-facts">
            <div className="detail-fact">
              <dt>Workshop Schedule</dt>
              <dd>August 7th: 1:00 PM - 5:00 PM<br />August 8th: 9:00 AM - 12:00 PM</dd>
            </div>
            <div className="detail-fact">
              <dt>Format</dt>
              <dd>This workshop was conducted in hybrid format - in person at the Jackson School of Geosciences in the Barrow Conference Room, and via Zoom.</dd>
            </div>
          </dl>
        </div>
      </section>

      <section className="audt-section u-spread detail-section">
        <h2 className="u-spread-label">Previous Workshops</h2>
        <div className="detail-section__body">
          <div className="detail-links">
            <a className="detail-link" href="/images/AUDT April 18th Workshop Schedule.pdf" target="_blank" rel="noopener noreferrer">
              City-Scale Applications Workshop<span className="detail-link__meta">April 18th, 2025 · Schedule</span>
            </a>
            <a className="detail-link" href="https://utexas.zoom.us/rec/share/xmI0Qo1UeV8-I52_w3Le33U4ZnxKyZ1Sex8j2MMX9Vg0l8s8pMhGqtMl5ZSJE1VQ.sabw7tvnxDX3dZM2?startTime=1744984513000" target="_blank" rel="noopener noreferrer">
              April 18th Workshop Zoom Recording<span className="detail-link__meta">April 18th, 2025 · Recording</span>
            </a>
            <a className="detail-link" href="https://utexas.zoom.us/rec/share/lh60TUr0gLrd3zVltI6hjkDWTqrFyx9tNdNVLWuIDp1cXwlSsbq-AmRDzVrtZYuq.umri03fi51-xtHY0" target="_blank" rel="noopener noreferrer">
              Building Energy and Urban Development Twins Workshop<span className="detail-link__meta">February 4th, 2025 · Recording</span>
            </a>
          </div>
        </div>
      </section>

      <section className="audt-section u-spread detail-section">
        <h2 className="u-spread-label">Project Leads and Participants</h2>
        <div className="detail-section__body">
          <ul className="detail-roster">
            <li>Dev Niyogi, Sergio Castellanos and Zoltan Nagy, The University of Texas at Austin</li>
            <li>Xinyue Ye, Texas A&amp;M University</li>
            <li>Ruby Leung, PNNL</li>
            <li>Yuhan "Douglas" Rao, North Carolina State University, Cooperative Institute for Satellite Earth System Studies</li>
            <li>Rob Redmon, NOAA NCEI and NOAA Center for AI</li>
            <li>Tan Bui-Thanh, Oden Institute, The University of Texas at Austin</li>
            <li>Daniel Aliaga, Purdue University</li>
            <li>Aditya Grover, UCLA</li>
            <li>Andrew Gettelman, PNNL and WCRP Digital Earth Lighthouse Activity</li>
            <li>Dru Crawley, Bentley Systems</li>
            <li>Ruchi Choudhary, Cambridge University and Stanford University (sabbatical)</li>
            <li>Bhanu Neupane, UNESCO</li>
            <li>Paulo Ferrao, Instituto Superior Técnico - University of Lisbon</li>
          </ul>
        </div>
      </section>

      <section className="audt-section u-spread detail-section" id="goal">
        <h2 className="u-spread-label">Background</h2>
        <div className="detail-section__body">
          <p>The primary goal of the AUDT workshop is to foster development, understanding, and application of digital twin technologies in atmospheric and urban contexts. This aims to support weather and climate studies through advanced simulations, visualizations, and analyses, leveraging the growing capabilities in artificial intelligence (AI) and machine learning (ML), coupled with vast computational resources. The workshop intends to bridge the gap between academic research and practical applications, emphasizing the integration of physical and social sciences to enhance urban sustainability and smart city initiatives.
          </p>
        </div>
      </section>

      <section className="audt-section u-spread detail-section" id="scope">
        <h2 className="u-spread-label">Scope of AUDT Workshop</h2>
        <div className="detail-section__body">
          <p>The scope of the workshop encompasses discussions related to definitions, applications, needs, opportunities, challenges and participation of academia in the development and widespread adoption of digital twins. It aims to:</p>
          <ul>
            <li>Develop clear definitions and requirements for atmospheric digital twins (ADTs) and urban digital twins (UDTs).</li>
            <li>Create exemplary demonstrators of AUDT to showcase their potential.</li>
            <li>Facilitate discussions on channeling various digital twin developments for enhanced weather and climate studies.</li>
          </ul>
          <p>The workshop will address the need for academic engagement in digital twin technology, focusing on areas not fully covered by current agency-driven efforts. It will explore the integration of ADTs and UDTs for improved urban planning and climate change adaptation, emphasizing the importance of interdisciplinary collaboration.</p>
        </div>
      </section>

      <section className="audt-section u-spread detail-section" id="participants">
        <h2 className="u-spread-label">Workshop Participants</h2>
        <div className="detail-section__body">
          <p>The workshop will bring together a diverse group of participants, including:</p>
          <ul>
            <li>Academics and researchers in atmospheric sciences, urban planning, computer science, and related fields</li>
            <li>Practitioners from the weather and climate enterprise, urban planning, and infrastructure development sectors.</li>
            <li>Representatives from government agencies, non-profit organizations, and industry stakeholders interested in the application of AUDT for urban sustainability.</li>
          </ul>
        </div>
      </section>

      <section className="audt-section u-spread detail-section" id="topics">
        <h2 className="u-spread-label">Breakout Topics</h2>
        <div className="detail-section__body">
          <p>The workshop will feature a range of breakout topics, including but not limited to:</p>
          <ul>
            <li>Definitions and standards for ADTs and UDTs.</li>
            <li>Integration of digital twins with AI and ML technologies for predictive modeling and simulations.</li>
            <li>Challenges and opportunities in representing urban components and dynamics within digital twins.</li>
            <li>Best practices and innovative approaches in developing and using AUDTs for climate change mitigation and urban planning.</li>
            <li>Case studies and demonstrator projects showcasing the application of AUDT in real-world scenarios.</li>
          </ul>
        </div>
      </section>

      <section className="audt-section u-spread detail-section" id="outcomes">
        <h2 className="u-spread-label">General Workshop Outcomes</h2>
        <div className="detail-section__body">
          <p>The anticipated outcomes of the workshop include:</p>
          <ul>
            <li>A white paper on the potential applications, challenges, and opportunities of combining atmospheric and urban digital twins, aimed at informing future research, policy-making, and urban planning efforts.</li>
            <li>Enhanced collaboration among the academic community, practitioners, and stakeholders in the development and application of AUDT technologies.</li>
            <li>Recommendations for integrating digital twin technologies into research and education, highlighting interdisciplinary opportunities and the need for a unified approach to urban sustainability and climate resilience.</li>
            <li>Establishment of a community of practice for ongoing dialogue, collaboration, and innovation in the field of atmospheric and urban digital twins.</li>
          </ul>
        </div>
      </section>

      </div>

    </div>

      <Footer />
    </>
  );

  
}

export default AUDT;
